var moduleMap = {
	"./change-password-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(998), __webpack_require__.e(235), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(73), __webpack_require__.e(496), __webpack_require__.e(746), __webpack_require__.e(464)]).then(() => (() => ((__webpack_require__(8464)))));
	},
	"./update-profile-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(998), __webpack_require__.e(176), __webpack_require__.e(145), __webpack_require__.e(235), __webpack_require__.e(910), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(73), __webpack_require__.e(819), __webpack_require__.e(752), __webpack_require__.e(746), __webpack_require__.e(109)]).then(() => (() => ((__webpack_require__(2109)))));
	},
	"./customer-listing-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(145), __webpack_require__.e(24), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(73), __webpack_require__.e(496), __webpack_require__.e(752), __webpack_require__.e(214), __webpack_require__.e(627)]).then(() => (() => ((__webpack_require__(6627)))));
	},
	"./customer-create-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(998), __webpack_require__.e(176), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(496), __webpack_require__.e(752), __webpack_require__.e(214), __webpack_require__.e(746), __webpack_require__.e(96), __webpack_require__.e(30)]).then(() => (() => ((__webpack_require__(7030)))));
	},
	"./customer-update-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(998), __webpack_require__.e(176), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(73), __webpack_require__.e(496), __webpack_require__.e(752), __webpack_require__.e(214), __webpack_require__.e(746), __webpack_require__.e(96), __webpack_require__.e(374)]).then(() => (() => ((__webpack_require__(374)))));
	},
	"./customer-view-page": () => {
		return Promise.all([__webpack_require__.e(874), __webpack_require__.e(388), __webpack_require__.e(998), __webpack_require__.e(176), __webpack_require__.e(927), __webpack_require__.e(342), __webpack_require__.e(602), __webpack_require__.e(290), __webpack_require__.e(73), __webpack_require__.e(496), __webpack_require__.e(752), __webpack_require__.e(214), __webpack_require__.e(250)]).then(() => (() => ((__webpack_require__(1250)))));
	},
	"./en/translation": () => {
		return __webpack_require__.e(447).then(() => (() => ((__webpack_require__(2447)))));
	},
	"./ms/translation": () => {
		return __webpack_require__.e(164).then(() => (() => ((__webpack_require__(5164)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});